import { Home, History, Users, TrendingUp, Wallet, Handshake } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { useViewMode } from '@/lib/view-mode-context';
import { useHaptics } from '@/hooks/use-haptics';
import { sounds } from '@/lib/sounds';
import { useUserSettings } from '@/lib/user-settings-context';

export default function BottomNav() {
  const { isPublic, targetUserId } = useViewMode();
  const { light } = useHaptics();
  const { settings } = useUserSettings();

  const handleNavClick = () => {
    if (settings.extra_juice) {
      light();
      sounds.play('pop');
    }
  };

  const getPath = (base: string) => {
    if (!isPublic) return base;
    if (base === '/') return `/public/${targetUserId}`;
    return `/public/${targetUserId}${base}`;
  };

  const tabs = [
    { to: getPath('/'), icon: Home, label: 'Home' },
    { to: getPath('/sessions'), icon: History, label: 'Sessions' },
    { to: getPath('/players'), icon: Users, label: 'Players' },
    ...(isPublic ? [
      { to: getPath('/who-pays-who'), icon: Handshake, label: 'Transfers' }
    ] : []),
    { to: getPath('/expenses'), icon: Wallet, label: 'Expenses' },
    { to: getPath('/statistics'), icon: TrendingUp, label: 'Stats' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border safe-area-bottom">
      <div className="flex items-center justify-around h-16 max-w-lg mx-auto">
        {tabs.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            onClick={handleNavClick}
            end={to === '/' || (isPublic && to === `/public/${targetUserId}`)}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center gap-0.5 px-3 py-2 rounded-xl transition-colors text-xs font-medium',
                isActive
                  ? 'text-primary'
                  : 'text-muted-foreground hover:text-foreground'
              )
            }
          >
            <Icon className="h-5 w-5" />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

